var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import DataTable from '@/components/data-table/DataTable';
import PageHeader from '@/components/page-header/PageHeader';
import { YearTemplate } from '@/models/YearTemplate';
import { RolesEnum } from '@/items/Roles';
import { Component, Vue } from 'vue-property-decorator';
import CreateDialog from './CreateDialog/CreateDialog';
let YearTemplates = class YearTemplates extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Schooljaar sjablonen';
        this.isCreating = false;
    }
    refreshDataTable() {
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    get canCreate() {
        return this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT]);
    }
    get tableOptions() {
        return {
            name: {
                singular: 'Sjabloon',
                plural: 'Sjablonen',
            },
            headers: [
                {
                    text: 'Naam',
                    value: 'name',
                },
                {
                    text: 'Schooljaar',
                    value: 'year_name',
                },
                {
                    text: 'Start',
                    value: 'starts_at',
                },
                {
                    text: 'Einde',
                    value: 'ends_at',
                },
                {
                    text: 'Periodes',
                    value: 'periods',
                    transform: (periods) => {
                        return periods ? periods.length.toString() : '0';
                    },
                },
            ],
            actions: [
                {
                    type: 'view',
                    label: 'bewerken',
                    icon: 'edit',
                    action: (vm, template) => {
                        this.$router.push({ name: 'admin.yearTemplate', params: { id: template.id } });
                    },
                },
            ],
            filters: [],
            model: new YearTemplate(),
        };
    }
};
YearTemplates = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            CreateDialog,
        },
    })
], YearTemplates);
export default YearTemplates;
